import clinicApi from '@/services/clinic/clinic.api'; // Импортируем ваш настроенный клиент

class ClinicService {
  constructor() {
    this.api = clinicApi;
  }

  addClinicToFavorite(clinicId) {
    return this.api.addClinicToFavorite(clinicId);
  }

  removeClinicFromFavorite(clinicId) {
    return this.api.removeClinicFromFavorite(clinicId);
  }
}

const clinicService = new ClinicService();
export default clinicService;
